
import { Heart } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-dark text-white py-12 px-4 sm:px-6 lg:px-8">
      <div className="container mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center mb-4">
              <img 
                src="/lovable-uploads/212af9c6-6d38-40f2-89e2-d669d9c615a9.png" 
                alt="SPTools Logo" 
                className="h-8 bg-white p-1 rounded" 
              />
            </div>
            <p className="text-gray-light mb-6 max-w-md">
              SPTools bietet leistungsstarke Erweiterungen und Lösungen für SharePoint und Microsoft 365, die Ihre Arbeitsabläufe optimieren und die Zusammenarbeit verbessern.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Quicklinks</h3>
            <ul className="space-y-2">
              <li>
                <a href="#vorteile" className="text-gray-light hover:text-blue-light transition-colors">
                  Vorteile
                </a>
              </li>
              <li>
                <a href="#anwendungsfaelle" className="text-gray-light hover:text-blue-light transition-colors">
                  Anwendungsfälle
                </a>
              </li>
              <li>
                <a href="#demo" className="text-gray-light hover:text-blue-light transition-colors">
                  Kontakt
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-white">Kontakt</h3>
            <ul className="space-y-2">
              <li className="text-gray-light">
                CCDS GmbH
              </li>
              <li className="text-gray-light">
                Email: info@sptools.de
              </li>
              <li className="text-gray-light">
                Web: sptools.de
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-700 text-center text-gray-light">
          <p className="text-sm">
            &copy; {currentYear} CCDS GmbH. Alle Rechte vorbehalten.
          </p>
          <p className="text-xs mt-2">
            *Microsoft, Office 365, SharePoint, Teams und OneDrive sind eingetragene Marken der Microsoft Corporation.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
